import { FC } from 'react'
import { IButton } from './IButton'
import styles from './styles.module.css'
import { Loader } from '../index'

const Button: FC<IButton> = ({ value, style, loader, disabled, onClick }) => {
	return (
		<button onClick={onClick} style={style} className={styles.button} disabled={disabled || loader}>
			{loader ? <Loader type='small' /> : value}
		</button>
	)
}

export default Button
